module.exports = __webpack_public_path__ + "img/face-sad.6d6afa0e.svg";